"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const Shared_1 = require("@/components/styled-controls/Shared");
const Layout_1 = __importDefault(require("@/components/organisms/Layout"));
const constant_1 = require("@/constants/constant");
const useApiService_1 = require("@/api/useApiService");
const TextInput_1 = __importDefault(require("@/components/atoms/TextInput"));
const Input_1 = require("@/components/styled-controls/Input");
const ValidationHelper_1 = require("@/helpers/ValidationHelper");
const js_cookie_1 = __importDefault(require("js-cookie"));
const PushFormSuccessValuestoDataLayer_1 = require("@/helpers/PushFormSuccessValuestoDataLayer");
const UserInfo_styles_1 = require("./UserInfo.styles");
const SelectDropdown_1 = __importDefault(require("@/components/atoms/SelectDropdown/SelectDropdown"));
/**
 * UserInfo component for submitting user's first name, last name and company name.
 */
const UserInfo = () => {
    const { setStep, userData, setUserData, appProps } = (0, UserRegistrationContext_1.useUserRegistration)();
    const { subscriptionApiUrl, analyticsPrefix, freemiumExtranetId, salesforceProxyApiUrl } = appProps;
    const [formState, setFormState] = (0, react_1.useState)({
        firstName: userData?.firstName || '',
        lastName: userData?.lastName || '',
        companyName: userData?.companyName || '',
        jobTitle: userData?.jobTitle || '',
        userIndustry: userData?.userIndustry || '',
    });
    const [validationError, setValidationError] = (0, react_1.useState)('');
    const [firstNameValidationError, setFirstNameValidationError] = (0, react_1.useState)('');
    const [lastNameValidationError, setLastNameValidationError] = (0, react_1.useState)('');
    const [companyNameValidationError, setCompanyNameValidationError] = (0, react_1.useState)('');
    const [jobTitleValidationError, setJobTitleValidationError] = (0, react_1.useState)('');
    const [userIndustryValidationError] = (0, react_1.useState)('');
    /**
     * State variable for tracking whether the form has been submitted.
     * This is used to control the display of validation messages.
     * Validation messages are only displayed once the form has been submitted.
     * This helps to improve the user experience by not showing validation errors before the user has had a chance to complete the form.
     */
    const [isSubmitted, setIsSubmitted] = (0, react_1.useState)(false);
    const [isButtonDisabled, setIsButtonDisabled] = (0, react_1.useState)(false); // Used to disable the button to prevent multiple submissions,
    const [industries, setIndustries] = (0, react_1.useState)([]);
    const isFormEmpty = Object.values(formState).includes(''); // used to disable the button if the form is not entirely filled out
    const { userService, handleResponse } = (0, useApiService_1.useApiService)();
    (0, react_1.useEffect)(() => {
        if (!salesforceProxyApiUrl) {
            setIndustries([]);
            return;
        }
        userService
            .fetchIndustries(salesforceProxyApiUrl)
            .then((data) => setIndustries(data))
            .catch(() => {
            setIndustries([]);
        });
    }, [userService, salesforceProxyApiUrl]);
    /**
     * Check if the user is registering via a referral link
     * If so, persist the referral data and send the data to Amplitude
     * Note: This is a one-time action and there is validation on the backend to prevent multiple submissions for the same email address of the invitee
     */
    (0, react_1.useEffect)(() => {
        const urlParams = new URLSearchParams(globalThis.location.search);
        const uid = urlParams.get('uid');
        const createdOnTimeStamp = urlParams.get('t');
        if (uid && createdOnTimeStamp) {
            globalThis.iiAna('track', constant_1.DATA_ANALYTICS_TAG.INVITE_A_COLLEAGUE.ACCEPTED(analyticsPrefix), {
                uid: uid,
                t: createdOnTimeStamp,
                ch: urlParams.get('ch'),
            });
        }
    }, []);
    /**
     * Handles the success response from the API call.
     * If the response contains a valid userId, updates the user data with the email and userId,
     * and sets the step to 'passwordAndCode'.
     * Otherwise, sets a validation error message indicating that something went wrong.
     * @param data - The response data from the API call.
     */
    const successHandler = () => {
        setUserData((prevData) => ({ ...prevData, ...formState }));
        deleteCookieForRemainingSteps();
        (0, PushFormSuccessValuestoDataLayer_1.pushFormSuccessValuestoDataLayer)({
            // push values to DL only after successful submission
            'form-name': `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-userinfo`,
            firstName: formState.firstName,
            lastName: formState.lastName,
            companyName: formState.companyName,
            jobTitle: formState.jobTitle,
            industry: industries.find((i) => i.id === formState.userIndustry)?.label || formState.userIndustry,
            email: userData.email,
            id: userData.id,
        });
        // Call refreshToken to populate GivenName in the token (fire and forget)
        const accessToken = js_cookie_1.default.get('em_at');
        fetch(`${subscriptionApiUrl}/RefreshToken`, {
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
            },
            method: 'POST',
        });
        setStep('industry');
    };
    /**
     * Once demographic user info is submitted, the freemium cookie for the remaining steps is not needed.
     * Deletes the freemium cookie for the remaining steps.
     */
    const deleteCookieForRemainingSteps = () => {
        js_cookie_1.default.set(constant_1.FREEMIUM.COOKIE_NAME, constant_1.FREEMIUM.REMAINING_STEPS.DEMOGRAPHICS, {
            expires: -1,
            domain: constant_1.FREEMIUM.COOKIE_DOMAIN,
        });
    };
    /**
     * Handles the next step in the user registration process.
     * If the form is valid, it submits the user's basic info to the server.
     * @returns {Promise<void>} A promise that resolves when the next step is handled.
     */
    const handleNext = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);
        setFirstNameValidationError('');
        setLastNameValidationError('');
        setCompanyNameValidationError('');
        setJobTitleValidationError('');
        if (isFormValid()) {
            try {
                setIsButtonDisabled(true);
                const response = await userService.submitUserInfo(`${subscriptionApiUrl}/demographics`, formState, userData.id, freemiumExtranetId);
                await handleResponse(response, successHandler, null);
                setIsButtonDisabled(false);
            }
            catch (error) {
                setValidationError(constant_1.SOMETHING_WENT_WRONG_ERROR);
                setIsButtonDisabled(false);
            }
        }
    };
    /**
     * Handles the change event for a specific field in the form.
     * @param field - The name of the field being changed.
     * @returns A function that takes the new value and validity of the field and updates the form state.
     */
    const handleChange = (field, validator) => (value) => {
        setFormState((prevState) => ({ ...prevState, [field]: value }));
        if (isSubmitted && validator) {
            validator(value);
        }
    };
    const handleIndustryChange = (field) => (event) => {
        const value = event.target.value;
        setFormState((prevState) => ({ ...prevState, [field]: value }));
    };
    const validateFirstName = (value) => {
        const [isValid, error] = (0, ValidationHelper_1.validateFormField)('First Name', value, constant_1.LENGTH_VALIDATION.FIRST_NAME, 2, /^[\p{L}\p{M}\-'\s]+$/u);
        setFirstNameValidationError(error);
        return isValid;
    };
    const validateLastName = (value) => {
        const [isValid, error] = (0, ValidationHelper_1.validateFormField)('Last Name', value, constant_1.LENGTH_VALIDATION.LAST_NAME, 2, /^[\p{L}\p{M}\-'\s]+$/u);
        setLastNameValidationError(error);
        return isValid;
    };
    const validateJobTitle = (value) => {
        const [isValid, error] = (0, ValidationHelper_1.validateFormField)('Job Title', value, constant_1.LENGTH_VALIDATION.JOB_TITLE, 3, /^[^<>]+$/);
        setJobTitleValidationError(error);
        return isValid;
    };
    const validateCompanyName = (value) => {
        const [isValid, error] = (0, ValidationHelper_1.validateFormField)('Company Name', value, constant_1.LENGTH_VALIDATION.COMPANY_NAME, 1, /^[^<>]+$/);
        setCompanyNameValidationError(error);
        return isValid;
    };
    /**
     * Validates the user's first name, last name, company name, and job title.
     * @returns {boolean} Returns true if all fields are valid, otherwise false.
     */
    const isFormValid = () => {
        const firstNameIsValid = validateFirstName(formState.firstName);
        const lastNameIsValid = validateLastName(formState.lastName);
        const companyNameIsValid = validateCompanyName(formState.companyName);
        const jobTitleIsValid = validateJobTitle(formState.jobTitle);
        return firstNameIsValid && lastNameIsValid && companyNameIsValid && jobTitleIsValid;
    };
    return (react_1.default.createElement(Layout_1.default, { registrationStepCopy: constant_1.HEADER_TEXTS.DEMOGRAPHICS.TITLE, subHeaderText: constant_1.HEADER_TEXTS.DEMOGRAPHICS.SUBTITLE, errorText: validationError },
        react_1.default.createElement(Input_1.RegistrationForm, { onSubmit: handleNext, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-userinfo`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.FORM}-userinfo` },
            react_1.default.createElement(UserInfo_styles_1.StyledTextInputContainer, null,
                react_1.default.createElement(TextInput_1.default, { type: "text", value: formState.firstName, maxLength: constant_1.LENGTH_VALIDATION.FIRST_NAME, onChange: handleChange('firstName', validateFirstName), validationError: firstNameValidationError, placeholder: constant_1.PLACEHOLDER_TEXTS.DEMOGRAPHICS.FIRST_NAME, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-firstname`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-firstname` }),
                react_1.default.createElement(TextInput_1.default, { type: "text", value: formState.lastName, maxLength: constant_1.LENGTH_VALIDATION.LAST_NAME, onChange: handleChange('lastName', validateLastName), validationError: lastNameValidationError, placeholder: constant_1.PLACEHOLDER_TEXTS.DEMOGRAPHICS.LAST_NAME, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-lastName`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-lastName` }),
                react_1.default.createElement(TextInput_1.default, { type: "text", value: formState.jobTitle, maxLength: constant_1.LENGTH_VALIDATION.JOB_TITLE, onChange: handleChange('jobTitle', validateJobTitle), validationError: jobTitleValidationError, placeholder: constant_1.PLACEHOLDER_TEXTS.DEMOGRAPHICS.JOB_TITLE, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-jobTitle`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-jobTitle` }),
                react_1.default.createElement(SelectDropdown_1.default, { value: formState.userIndustry, onChange: handleIndustryChange('userIndustry'), placeholder: constant_1.PLACEHOLDER_TEXTS.DEMOGRAPHICS.INDUSTRY, validationError: userIndustryValidationError, options: industries.map((i) => ({ value: i.id, label: i.label })), id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.SELECT}-industry`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.SELECT}-industry` }),
                react_1.default.createElement(TextInput_1.default, { type: "text", value: formState.companyName, maxLength: constant_1.LENGTH_VALIDATION.COMPANY_NAME, onChange: handleChange('companyName', validateCompanyName), validationError: companyNameValidationError, placeholder: constant_1.PLACEHOLDER_TEXTS.DEMOGRAPHICS.COMPANY_NAME, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-companyname`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.TEXTBOX}-companyname` })),
            react_1.default.createElement(Shared_1.ButtonContainer, null,
                react_1.default.createElement(Shared_1.StyledButton, { forwardedAs: "button", buttonType: "default", dataAnalytics: constant_1.DATA_ANALYTICS_TAG.DEMOGRAPHICS.NEXT(analyticsPrefix), size: "m", disabled: isButtonDisabled || isFormEmpty, "$isDisabled": isButtonDisabled || isFormEmpty, id: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-next-userinfo`, name: `${constant_1.AMPLITUDE_IDENTIFY_TAGS.BUTTON}-next-userinfo` }, "Next")))));
};
exports.default = UserInfo;
